import { createRoute } from '@tanstack/react-router';

import { Changelog } from '~features/changelog';
import { rootRoute } from './__root';

const changelogRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/changelog',
  component: Changelog,
  loader: () => ({ crumb: 'Release notes' }),
});

export { changelogRoute };
